import { useEffect } from 'react';
import useLearningRoutes from '@/context/routes/hook';
import { routesService } from '@/services/routes';

const useUpdateLastVisit = ({ userRouteProgressId }: { userRouteProgressId?: string }) => {
  const { updateRoute } = useLearningRoutes();

  useEffect(() => {
    if (!userRouteProgressId) return;
    routesService
      .updateRouteProgress(userRouteProgressId, {
        lastVisitedAt: new Date().toISOString(),
      })
      .then((updatedUserProgress) => {
        updateRoute(updatedUserProgress.routeId, { lastInteraction: updatedUserProgress.lastVisitedAt });
      })
      .catch((error) => {
        console.error('Error updating last interaction:', error);
      });
  }, [userRouteProgressId, updateRoute]);
};

export default useUpdateLastVisit;
